export const isCaseInReview = (status?: Maybe<CaseStatus>) => {
  if (!status) {
    return false
  }

  const allowedStatuses: CaseStatus[] = ['REVIEW', 'POST_RECOMMENDATION_REVIEW']

  return allowedStatuses.includes(status)
}

export const isGeneralProtection = (mortgageReason?: Maybe<MortgageReason>) => {
  if (!mortgageReason) return false

  const allowedMortgageReasons: MortgageReason[] = ['REASON_PROTECTION', 'REASON_BUSINESS_PROTECTION']

  return allowedMortgageReasons.includes(mortgageReason)
}

export const isGeneralInsurance = (mortgageReason?: Maybe<MortgageReason>) => {
  if (!mortgageReason) return false

  return mortgageReason === 'REASON_GENERAL_INSURANCE'
}

export const shouldShowSuitabilityReport = (has_client_accepted_protection_advice?: Maybe<boolean>) => {
  if (!has_client_accepted_protection_advice) {
    return false
  }
  return has_client_accepted_protection_advice
}

export const isBusinessProtection = (mortgageReason?: Maybe<MortgageReason>) => {
  if (!mortgageReason) return false

  return mortgageReason === 'REASON_BUSINESS_PROTECTION'
}

export const isHomeInsurance = (mortgageReason?: Maybe<MortgageReason>) => {
  if (!mortgageReason) return false

  return mortgageReason === 'REASON_GENERAL_INSURANCE'
}

export const isManualProtection = (productsDetails?: ProtectionProductDetails[]): boolean => {
  if (productsDetails && productsDetails[0].source_response) {
    const source_response = JSON.parse(productsDetails[0].source_response)
    if (source_response.solutions.length === 0) {
      return true
    }
  }
  return false
}

export const shouldShowProtectionReferral = (mortgageReason?: Maybe<MortgageReason>) => {
  if (!mortgageReason) {
    return false
  }

  const mortgageReasonsToShowProtectionReferral: MortgageReason[] = [
    'REASON_FTB',
    'REASON_HOUSE_MOVE',
    'REASON_REMORTGAGE',
    'REASON_FURTHER_ADVANCE',
    'REASON_BTL',
    'REASON_BTL_REMORTGAGE',
  ]

  return mortgageReasonsToShowProtectionReferral.includes(mortgageReason)
}

const englandAndWalesLocations: PropertyLocation[] = ['ENGLAND_WALES', 'ENGLAND', 'WALES']

export const isInEnglandAndWales = (propertyLocation: string | PropertyLocation) => {
  return englandAndWalesLocations.includes(propertyLocation as PropertyLocation) || propertyLocation === 'GB'
}
